import styled from 'styled-components';

const Title = styled.p`
  text-align: center;
  font-size: 1.75rem;
  margin-bottom: 0;
  font-weight: 500;
  text-transform: uppercase;
`;

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  background-color: ${({ theme, isError }) => isError ? theme.colors.negative_bg : theme.colors.attention_bg};
  border: 1px solid ${({ theme, isError }) => isError ? theme.colors.negative : theme.colors.attention};
  color: ${({ theme }) => theme.colors.heading_dark};
`;

function ProcessingCheckMultimedia() {

  return (
    <Grid>
      <div>
        <Title>Processing uploaded multimedia...</Title>
      </div>
    </Grid>
  );
}

export default ProcessingCheckMultimedia;